const contactMatter = [
    {
        id: 1,
        matterName: "Contract Dispute",
        note: "Client facing issues with vendor contract.",
        matterRate: "200 USD/hour",
        invoiceTemplate: "Standard Template",
        dates: {
            StatuteOfLimitations: "2026-05-15",
            OpenDate: "2024-01-10",
            CloseDate: "2024-06-20"
        },
        assignedTo: {
            avatar: "300-34.png",
            name: "Jessica Wright",
        },
        OriginatingAttorney: "Jane Smith",
        tags: "contract, dispute",
        status: "Open",
        matterNumber: "MAT-1001"
    },
    {
        id: 2,
        matterName: "Personal Injury",
        note: "Car accident case with insurance claim.",
        matterRate: "250 USD/hour",
        invoiceTemplate: "Injury Claim Template",
        dates: {
            StatuteOfLimitations: "2027-09-30",
            OpenDate: "2024-02-18",
            CloseDate: "2024-08-12"
        },
        assignedTo: {
            avatar: "300-1.png",
            name: "Sarah Carter",
        },
        OriginatingAttorney: "Michael Brown",
        tags: "injury, insurance",
        status: "Pending",
        matterNumber: "MAT-1002"
    },
    {
        id: 3,
        matterName: "Real Estate Dispute",
        note: "Property boundary issue between neighbors.",
        matterRate: "180 USD/hour",
        invoiceTemplate: "Real Estate Template",
        dates: {
            StatuteOfLimitations: "2025-11-22",
            OpenDate: "2023-12-05",
            CloseDate: "2024-07-18"
        },
        assignedTo: {
            avatar: "300-2.png",
            name: "Nathan Fox",
        },
        OriginatingAttorney: "Sophia Martinez",
        tags: "real estate, dispute",
        status: "Closed",
        matterNumber: "MAT-1003"
    },
    {
        id: 4,
        matterName: "Intellectual Property",
        note: "Trademark infringement case.",
        matterRate: "300 USD/hour",
        invoiceTemplate: "IP Case Template",
        dates: {
            StatuteOfLimitations: "2028-04-10",
            OpenDate: "2024-03-22",
            CloseDate: "2024-09-25"
        },
        assignedTo: {
            avatar: "300-3.png",
            name: "Ethan Brooks",
        },
        OriginatingAttorney: "Robert Garcia",
        tags: "trademark, IP",
        status: "Open",
        matterNumber: "MAT-1004"
    },
    {
        id: 5,
        matterName: "Employment Dispute",
        note: "Wrongful termination lawsuit.",
        matterRate: "220 USD/hour",
        invoiceTemplate: "Employment Template",
        dates: {
            StatuteOfLimitations: "2026-07-14",
            OpenDate: "2024-01-30",
            CloseDate: "2024-10-05"
        },
        assignedTo: {
            avatar: "300-33.png",
            name: "Guy Hawkins",
        },
        OriginatingAttorney: "William Anderson",
        tags: "employment, termination",
        status: "Open",
        matterNumber: "MAT-1005"
    },
    {
        id: 6,
        matterName: "Criminal Defense",
        note: "Fraud charges defense case.",
        matterRate: "280 USD/hour",
        invoiceTemplate: "Criminal Template",
        dates: {
            StatuteOfLimitations: "2029-12-01",
            OpenDate: "2024-04-15",
            CloseDate: "2024-11-30"
        },
        assignedTo: {
            avatar: "300-32.png",
            name: "Jessica Wright",
        },
        OriginatingAttorney: "Elizabeth Thomas",
        tags: "criminal, fraud",
        status: "Open",
        matterNumber: "MAT-1006"
    },
    {
        id: 7,
        matterName: "Family Law",
        note: "Divorce and child custody case.",
        matterRate: "190 USD/hour",
        invoiceTemplate: "Family Law Template",
        dates: {
            StatuteOfLimitations: "2025-06-20",
            OpenDate: "2024-02-10",
            CloseDate: "2024-07-30"
        },
        assignedTo: {
            avatar: "300-31.png",
            name: "Jessica Wright",
        },
        OriginatingAttorney: "Charlotte White",
        tags: "family, custody",
        status: "Closed",
        matterNumber: "MAT-1007"
    },
    {
        id: 8,
        matterName: "Corporate Compliance",
        note: "Regulatory compliance audit.",
        matterRate: "260 USD/hour",
        invoiceTemplate: "Corporate Template",
        dates: {
            StatuteOfLimitations: "2027-03-05",
            OpenDate: "2024-05-08",
            CloseDate: "2024-12-15"
        },
        assignedTo: {
            avatar: "300-30.png",
            name: "Jessica Wright",
        },
        OriginatingAttorney: "Amelia Walker",
        tags: "corporate, compliance",
        status: "Open",
        matterNumber: "MAT-1008"
    },
    {
        id: 9,
        matterName: "Tax Litigation",
        note: "Dispute with IRS over tax filing.",
        matterRate: "275 USD/hour",
        invoiceTemplate: "Tax Template",
        dates: {
            StatuteOfLimitations: "2026-10-25",
            OpenDate: "2024-06-12",
            CloseDate: "2025-01-18"
        },
        assignedTo: {
            avatar: "300-29.png",
            name: "Jessica Wright",
        },
        OriginatingAttorney: "Samantha Allen",
        tags: "tax, IRS",
        status: "Open",
        matterNumber: "MAT-1009"
    },
    {
        id: 10,
        matterName: "Bankruptcy Filing",
        note: "Chapter 7 bankruptcy case.",
        matterRate: "230 USD/hour",
        invoiceTemplate: "Bankruptcy Template",
        dates: {
            StatuteOfLimitations: "2028-01-30",
            OpenDate: "2024-07-20",
            CloseDate: "2025-02-28"
        },
        assignedTo: {
            avatar: "300-28.png",
            name: "Jessica Wright",
        },
        OriginatingAttorney: "Victoria Scott",
        tags: "bankruptcy, finance",
        status: "Open",
        matterNumber: "MAT-1010"
    }
];

export { contactMatter };